import Cookies from 'js-cookie'

$(document).ready(function () {
  /*
   ** Confirmation links
   */

  let confirmLinks = document.querySelectorAll('a[data-confirm]')
  confirmLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      $('#confirm-modal').modal({ show: true })
      document
        .querySelector('a#confirmHref')
        .setAttribute('href', event.target.parentNode.href)
      event.preventDefault()
      return false
    })
  })

  /*
   ** Select2
   */

  $('select:not(#change-object, .noselect2)')
    .removeClass('form-control')
    .select2({
      minimumResultsForSearch: 5
    })
  $('select#change-object').select2()

  $('.multiselect').multiselect()

  /*
   ** Custom tooltips
   */

  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })

  $('#notification-tooltip').on('shown.bs.tooltip', function () {
    var csrftoken = Cookies.get('csrftoken')
    $.ajaxSetup({
      beforeSend: function (xhr, settings) {
        xhr.setRequestHeader('X-CSRFToken', csrftoken)
      }
    })
    $.ajax({
      url: '/message/toggle/',
      type: 'POST'
    })
  })

  /*
   ** Websockets
   */

  const wsScheme = window.location.protocol == 'https:' ? 'wss' : 'ws'
  const wsHost = wsScheme + '://' + window.location.host

  const wsCloseInfo = function (event, wsType) {
    if (event.code !== 1000) {
      console.error(wsType + ' socket closed unexpectedly')
      console.log(event)
    }
  }

  // Tasks
  const wsTaskUri = wsHost + '/ws/tasks/'
  const taskSocket = new WebSocket(wsTaskUri)

  taskSocket.onmessage = function (e) {
    const data = JSON.parse(e.data)
    const nbCurrentTasks = data.message['nb_current_tasks']
    if (nbCurrentTasks > 0)
      $('#task-count').attr('data-badge', nbCurrentTasks).show()
    else $('#task-count').removeAttr('data-badge')
  }

  taskSocket.onclose = function (e) {
    wsCloseInfo(e, 'Task')
  }

  // Notifications
  const wsNotificationUri = wsHost + '/ws/notifications/'
  const notificationsSocket = new WebSocket(wsNotificationUri)

  notificationsSocket.onmessage = function (e) {
    const data = JSON.parse(e.data)
    const nbUnreadNotifications = data.message['nb_unread_notifications']
    if (nbUnreadNotifications > 0)
      $('#notification-count').attr('data-badge', nbUnreadNotifications).show()
    else $('#notification-count').removeAttr('data-badge')
  }

  notificationsSocket.onclose = function (e) {
    wsCloseInfo(e, 'Notification')
  }

  // Install
  const wsInstallUri = wsHost + '/ws/install/'
  const installSocket = new WebSocket(wsInstallUri)

  installSocket.onmessage = function (e) {
    $('#install').hide()
    $('#installok').removeClass('hide')
  }

  installSocket.onclose = function (e) {
    wsCloseInfo(e, 'Install')
  }
})
